<template>
  <div id="app">
    <div class="wrap" v-if="!pickupFinishYn" :class="{positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />

      <div class="payment">
        <div class="process">
          <div class="step-wrap">
            <span class="step step--n01 on" :class="{checked: !pickupYn}">01</span>
            <span class="step-txt">{{ $t('User.Pickup.msg1') }}</span>
          </div>
          <div class="step-wrap">
            <span class="step step--n02" :class="{on: qrCodeYn || mobileNumberYn, 'on checked': !qrCodeYn && !pickupYn && !mobileNumberYn}">02</span>
            <span class="step-txt">{{ $t('User.Pickup.msg2') }}</span>
          </div>
          <div class="step-wrap">
            <span class="step step--n03" :class="{on: pickupCheckYn}">03</span>
            <span class="step-txt">{{ $t('User.Pickup.msg3') }}</span>
          </div>
        </div>

        <!-- 아래 요소 높이 일정해야 함 -->
        <div class="payment__content" v-if="pickupYn">
          <!-- header -->
          <div class="layer__header">
            <div class="lyr-title">{{ $t('User.Pickup.PickupSelect.msg1') }}</div>
            <div class="ft-point">
              {{ $t('User.Pickup.PickupSelect.msg2') }}
            </div>
          </div>
          <!-- //header -->

          <div class="payment__body">
            <div class="inner-pd">
              <div class="flex-col">
                <button
                  class="btn--box ico-qr btn-anim"
                  @mouseup="
                    pickupYn = false;
                    qrCodeYn = true;
                    pickupType = 'QR';
                  "
                >
                  <span class="ft--2xlg">{{ $t('User.Pickup.PickupSelect.msg3') }}</span>
                  <span class="ft--xlg ft--point">{{ $t('User.Pickup.PickupSelect.msg4') }}</span>
                </button>
                <button
                  class="btn--box ico-num btn-anim"
                  @mouseup="
                    pickupYn = false;
                    mobileNumberYn = true;
                    pickupType = 'MO';
                  "
                >
                  <span class="ft--2xlg">{{ $t('User.Pickup.PickupSelect.msg5') }}</span>
                  <span class="ft--xlg ft--point">{{ $t('User.Pickup.PickupSelect.msg6') }}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="layer__button">
            <button class="btn btn--line btn--xlg btn-anim" @mouseup="$router.push('/user/idle')">{{ $t('User.Pickup.PickupSelect.msg7') }}</button>
          </div>
        </div>

        <QrCode
          @closeQrCode="
            pickupYn = true;
            qrCodeYn = false;
          "
          @setCheck="
            qrCodeYn = false;
            pickupCheckYn = true;
          "
          v-if="qrCodeYn"
        />

        <MobileNumber
          @closeMobileNumber="
            pickupYn = true;
            mobileNumberYn = false;
          "
          @setCheck="
            mobileNumberYn = false;
            pickupCheckYn = true;
          "
          v-if="mobileNumberYn"
        />

        <PickupCheck
          @closeCheck="
            pickupCheckYn = false;
            if (pickupType == 'QR') qrCodeYn = true;
            else mobileNumberYn = true;
          "
          @setFinish="
            pickupFinishYn = true;
            pickupNum = 1;
          "
          v-if="pickupCheckYn"
        />

        <PickupCheckError
          @closeError="
            pickupCheckErrorYn = false;
            if (pickupType == 'QR') qrCodeYn = true;
            else mobileNumberYn = true;
          "
          v-if="pickupCheckErrorYn"
        />

        <BtnBottom />
      </div>
    </div>

    <PickupFinish v-if="pickupFinishYn" :pickupNum="pickupNum" />
  </div>
</template>
<script>
import helperHeight from '@/components/common/HelperHeight.vue';
import btnBottom from '@/components/user/order/BtnBottom.vue';
import qrCode from '@/components/user/pickup/QrCode.vue';
import mobileNumber from '@/components/user/pickup/MobileNumber.vue';
import pickupCheck from '@/components/user/pickup/PickupCheck.vue';
import pickupCheckError from '@/components/user/pickup/PickupCheckError.vue';
import pickupFinish from '@/components/user/pickup/PickupFinish.vue';

export default {
  name: 'order',
  methods: {},
  mounted() {
    this.$logInfo(`Enter Pickup pages`);

    this.$changeDarkMode(this.darkModeYn);
    this.$showButtonAnimation();
  },
  data() {
    return {
      pickupYn: true,
      qrCodeYn: false,
      mobileNumberYn: false,
      pickupCheckYn: false,
      pickupType: '',
      pickupFinishYn: false,
      pickupNum: 0,
      pickupCheckErrorYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  components: {
    BtnBottom: btnBottom,
    QrCode: qrCode,
    MobileNumber: mobileNumber,
    PickupCheck: pickupCheck,
    PickupFinish: pickupFinish,
    PickupCheckError: pickupCheckError,
    HelperHeight: helperHeight,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped></style>
